import React from 'react';
import Image from 'next/image';

import { PARTNER_STORE } from '../../domain/repo/store/PartnerStore';
import { cityToGeoRegionId } from '../../domain/repo/types/CityConfig';
import { close_icon } from '../../view-modal/PartnerVm';
import { usePartnerForm } from '../hooks/usePartnerForm';
import styles from '../styles/AttachVehicleModal.module.scss';

import PartnersFormAckCmp from './PartnersFormAckCmp';
import PartnersFormCmp from './PartnersFormCmp';

interface AttachVehicleModalProps {
  readonly modalState: boolean;
  readonly close_modal: () => void;
}

function AttachVehicleModal({
  modalState,
  close_modal,
}: AttachVehicleModalProps): React.ReactElement | null {
  const {
    city,
    setCity,
    vehicles,
    formSubmitStatus,
    partnerCities,
    infoSourceList,
    submitFormData,
    resetForm,
  } = usePartnerForm('bangalore');

  const closeModalHandler = (): void => {
    resetForm();
    close_modal();
  };

  if (!modalState) return null;

  return (
    <div
      className={styles['attach-vehicle-modal-overlay']}
      aria-label="Close modal overlay"
      onClick={(e) => {
        if (e.target === e.currentTarget) close_modal();
      }}
    >
      <div className={styles['attach-vehicle-modal']}>
        <div
          className={`${styles['modal-container']} ${styles['attach-form-container']}`}
        >
          {formSubmitStatus.status === 'init' && (
            <>
              <div className={styles['modal-titlebar']}>
                <div className={styles['title']}>
                  <b>{PARTNER_STORE.attach_vehicle_title}</b>
                </div>
                <button
                  type="button"
                  className={styles['close-btn']}
                  onClick={() => close_modal()}
                >
                  <Image
                    height={close_icon.height}
                    width={close_icon.width}
                    src={close_icon.src}
                    alt={close_icon.alt}
                  />
                </button>
              </div>
              <PartnersFormCmp
                initialCity={{ id: cityToGeoRegionId(city), name: city }}
                setCity={(c) => setCity(c)}
                submitPartnerDetailsInfo={submitFormData}
                cities={partnerCities}
                vehicles={vehicles}
                infoSourceList={infoSourceList}
              />
            </>
          )}
          {formSubmitStatus.status === 'live' && (
            <>
              <button
                type="button"
                className={`${styles['close-btn']} ${styles['ack-close-btn']}`}
                onClick={() => closeModalHandler()}
              >
                <Image
                  height={close_icon.height}
                  width={close_icon.width}
                  src={close_icon.src}
                  alt={close_icon.alt}
                />
              </button>
              <PartnersFormAckCmp
                message={formSubmitStatus.data.message}
                name={formSubmitStatus.data.name}
                resetFunc={resetForm}
              />
            </>
          )}
          {formSubmitStatus.status === 'loading' && (
            <div className={styles['loading']}>
              {PARTNER_STORE.loading_text}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default AttachVehicleModal;
